import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';
import { useT } from '../i18n/LanguageContext';

export default function Testimonials() {
  const { t } = useT();

  return (
    <section className="py-24 uc-mint-bg">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <p className="uc-kicker mb-3">{t('test.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">{t('test.heading')}</h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex">
              {[1, 2, 3, 4, 5].map((s) => (
                <Star key={s} size={22} className="text-[#ffb020] fill-[#ffb020]" />
              ))}
            </div>
            <span className="text-[#5b6469] ml-2">{t('test.count')}</span>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((tst) => (
            <div key={tst.id} className="uc-testimonial uc-lift relative">
              <Quote size={28} className="text-[#4dbfae]/30 mb-3" />
              <div className="flex mb-3">
                {[...Array(tst.rating)].map((_, i) => (
                  <Star key={i} size={16} className="text-[#ffb020] fill-[#ffb020]" />
                ))}
              </div>
              <p className="text-[#2b2e33] text-sm leading-relaxed mb-5">{tst.text}</p>
              <div className="flex items-center gap-3 pt-4 border-t border-[#eef6f4]">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[#4dbfae] to-[#7fe0ce] flex items-center justify-center text-white font-semibold">
                  {tst.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-[#1a2851] text-sm">{tst.name}</p>
                  <p className="text-xs text-[#5b6469]">Posted on {tst.source}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
